import init, { initWidgets } from 'src/lib/init.js'
import { initMoveable } from './moveable.js'
import { initChangeStatus } from 'src/lib/change-status.js'

import Vue from 'vue'
import rootComponent from '@/root/item-page.js'

import 'src/styles/aristotle.wizard.less'
import 'src/styles/aristotle_search.less'
import 'src/styles/conceptlink.css'

export function initItemPage() {
    init()
    initMoveable()

    $(document).ready(function() {
        $('.modal').on('loaded.bs.modal', function() {
            initChangeStatus()
            initWidgets()
            initMoveable()
        })
    })

    new Vue(rootComponent)
}
